import { render, staticRenderFns } from "./FilesAttachedToContactNotes.vue?vue&type=template&id=977bf932&scoped=true&"
import script from "./FilesAttachedToContactNotes.vue?vue&type=script&lang=js&"
export * from "./FilesAttachedToContactNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "977bf932",
  null
  
)

export default component.exports